export const awards = {
  awardsHero: {
    subtitle: 'AWARDS & ACTIVITIES',
    title: 'Awards & Social Activities',
  },
  manifesto: {
    title: 'GLOBAL RECOGNITION',
    subtitle: 'UN CSW70 Forum — Recipient of the "Outstanding Contribution Award"',
    text: {
      paragraph1: {
        line1: 'On March 10, 2026, at a forum related to',
        line2: 'the 70th Session of the UN Commission on the Status of Women (CSW70) held in New York,',
        line3: 'the educational framework of our academy received international recognition.',
      },
      paragraph2: {
        line1: 'Our unique human development program — integrating neuroscience, behavioral psychology, success philosophy, and cutting-edge AI technology —',
        line2: 'was recognized for its contribution to women\'s empowerment and the realization of a sustainable society.',
        line3: 'IDIO, an organization holding Special Consultative Status with the UN Economic and Social Council (ECOSOC),',
        line4: 'presented the "Outstanding Contribution Award" to Representative Director Shinji Hirose.',
      },
    },
    speech: {
      caption: 'SPEECH AT UN CSW70 FORUM · NEW YORK · 2026',
      heading: 'THE NY MANIFESTO',
      subheading: 'New York International Conference 2026 — A Declaration to the World',
      paragraph1: 'Every person holds infinite potential.',
      paragraph2: 'Education transforms thought, thought transforms action, and action transforms life.\nThis chain is the most certain structure for creating a sustainable society.',
      paragraph3: 'Gender equality is not merely a matter of rights —\nit is a growth strategy for society as a whole.\nDREAM CODE provides a framework through which anyone can redesign\ntheir own potential as a "structure."',
      paragraph4: 'Toward a world where no one is left behind.\nWe will continue to expand our efforts, merging education and technology,\nso that people around the world can realize their dreams.',
    },
    speechSignature: {
      name: 'Chairman, Dream Realization Academy — Shinji Hirose',
      date: 'March 10, 2026 / New York',
    },
    signature: {
      line1: 'Dream Realization Academy Chairman',
      line2: 'Shinji Hirose',
      line3: 'March 10, 2026 / New York',
    },
  },
  initiatives: {
    title: 'Three Social Transformation Models Recognized by the United Nations',
    items: [
      {
        title: 'Reconstruction of Self-Esteem and Goal Achievement',
        description: 'Providing educational support for single mothers and girls through a neuroscientific approach to build a "structure of independence" that does not depend on environment.',
      },
      {
        title: 'Understanding Business Structure and Income Generation',
        description: 'Rather than mere support, promoting sustainable economic independence through business education programs for women entrepreneurs.',
      },
      {
        title: 'Cultivating Next-Generation Digital Leaders',
        description: 'Integrating AI and digital technology into the curriculum to form cognitive models for women leaders who will lead the next generation of society.',
      },
    ],
  },
  activities: {
    title: 'Social Contribution',
    description: 'The DREAM CODE educational system has been implemented in various settings in Japan, including corporate training, community activities, and educational support, continuously producing reproducible results.',
    link: 'Explore our social implementation',
  },
};